<template>
  <div class="Menu" v-click-outside="hide" :class="class_root">
    <div class="Menu--logo">
      <router-link to="/" @click.native="hide(); $scrollToTop();">
        <Vector :svg="svg.logo"></Vector>
      </router-link>
    </div>
    <div class="Menu--links">
      <ul class="Menu--link">
        <li>
          <a @mouseenter="show(0)">Conseil</a>
        </li>
        <li>
          <router-link to="/formation" @click.native="hide(); $scrollToTop();">
            Formation
          </router-link>
        </li>
        <li>
          <a @mouseenter="show(1)">Évolution professionnelle</a>
        </li>
        <li>
          <a @mouseenter="show(2)">Nous connaitre</a>
        </li>
      </ul>
    </div>
    <div class="Menu--contact">
      <router-link to="/contact" @click.native="hide(); $scrollToTop();">
        <ContactButton></ContactButton>
      </router-link>
    </div>
    <MenuSub :props="this.componentKey" :class="'Position-' + this.componentKey"/>
    <MenuResponsive :side="'left'"/>
  </div>
</template>

<script>
import ContactButton from "../contact/ContactButton.vue"
import MenuSub from "./MenuSub.vue"
import MenuResponsive from "./MenuResponsive.vue"
import ClickOutside from 'vue-click-outside'
import {eventService} from "../../service/eventService";
import {ListenerRegister} from "@bbx/listener~master/core/delta/ListenerRegister";
import {EVENT} from "../../constant/EVENT";

export default {
  name: 'Menu',
  data() {
    return {
      events: [],
      state: {
        displayed: false,
      },
      componentKey: null,
      svg: {
        logo: require('../../../../assets/logo/logo.svg')
      }
    }
  },
  components: {
    ContactButton,
    MenuSub,
    MenuResponsive
  },
  computed: {
    class_root() {
      const classes = []
      if (this.state.displayed) classes.push(`Menu-displayed`)
      return classes
    }
  },
  methods: {
    show(id) {
      this.componentKey = id;
    },
    hide() {
      this.componentKey = null;
    }
  },
  directives: {
    ClickOutside
  },
  beforeMount() {
    this.events.push(new ListenerRegister({
      name: EVENT.START_ANIMATION,
      callback: () => {
        this.state.displayed = true
      }
    }))

    // -----

    for (const event of this.events) {
      eventService.register(event)
    }
  },
  beforeDestroy() {
    for (const event of this.events) {
      eventService.unregister(event)
    }
  },
}
</script>

<style scoped>
/* 
*   Global
*/
.Menu {
  z-index: 10;
  width: calc(100% - 200px);
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  padding: 10px 20px;
  margin-left: 100px;
  background-color: #FFFFFF;
  border-radius: 0 0 8px 8px;
  display: flex;
  align-items: center;
  align-content: space-between;
  box-shadow: 0px 10px 30px 5px rgba(119, 119, 119, 0.1);
  transform: translateY(-100%);
  transition: transform 500ms;
}

.Menu-displayed {
  transform: translateY(0);
}

.Menu--links {
  flex-grow: 2;
  font-size: 12px;
}

.Menu--contact {
  text-align: center;
}

.Menu--contact a {
  text-decoration: none;
}

/* 
*   Logo
*/

.Menu--logo {
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.Menu--logo a {
  display: block;
  width: 125px;
}

.Menu--logo >>> .Vector {

}

/* 
*   Link
*/
.Menu--link {
  list-style-type: none;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  align-content: space-between;
  justify-content: flex-end;
}

.Menu--link li {
  margin-right: 30px;
  cursor: pointer;
  text-decoration: none;
}

.Menu--link li a {
  text-decoration: none;
  color: black;
}

/* 
* Responsive
*/
@media (max-width: 1135px) {
  .Menu--logo {
    display: none;
  }

  .Menu--links {
    display: none;
  }

  .Menu--contact {
    display: none;
  }

  .Menu {
    background-color: transparent;
    width: 100%;
    margin: auto;
    padding: 0;
  }
}
</style>